import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CustomInput from "../constants/CustomInput";
import CustomTextArea from "../constants/CustomTextArea";
import CustomDropdown from "../constants/CustomDropdown";
import { CustomChairmanMail } from "../constants/CustomChairmanMail";
import {
  setdepartmentData,
  setLabCategoryData,
  setBloomsDomainData,
  setBloomsLevelData,
  setDeliveryMethodData,
  setMapLevelWeightageData,
  setProgramTypeData,
  setProgramData,
  setCourseData,
  setProgramModeData,
  setProgramOutcomeData,
  setQuestionBankData,
  setCourseCurriculumData,
  setCourseOutcomeData,
  getdepartmentData,
  getProgramTypeData,
  getProgramModeData,
} from "../redux/actions/dataAction";
import { connect } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import CustomButton from "./CustomButton";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#00293B",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  input: {
    width: "10px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog(props) {
  useEffect(() => {
    props.getdepartmentData();
    props.getProgramTypeData();
    props.getProgramModeData();
  }, []);

  const classes = useStyles();
  let history = useHistory();
  const [state, dataState] = useState({
    name: "",
    short_name: "",
    year_of_establishment: "",
    description: "",
    chairman: CustomChairmanMail,
    vision: "",
    mission: "",
    faculty: "",
    no_of_journals: "",
    no_of_magazines: "",
    professional_bodies: "",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
    created_by: "admin@test.com",
  });
  const [labCategory, setLabCategory] = useState({
    name: "",
    description: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [bloomDomain, setBloomDomain] = useState({
    name: "",
    description: "",
    acronym: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [bloomLevel, setBloomLevel] = useState({
    name: "",
    level_of_learning: "",
    characteristics_of_learning: "",
    action_verb: "",
    domain: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [deliveryMethod, setDeliveryMethod] = useState({
    name: "",
    guidelines: "",
    bloom_level: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [mapLevelWeightage, setMapLevelWeightage] = useState({
    name: "",
    acronym: "",
    status: true,
    weightage: null,
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [programType, setProgramType] = useState({
    name: "",
    description: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [program, setprogram] = useState({
    specialization: "",
    specialization_acronym: "",
    number_of_terms: "",
    total_credits: "",
    term_min_credits: "",
    term_max_credits: "",
    title: "",
    acronym: "",
    minimum_duration_qty: "",
    minimum_duration_unit: "",
    maximum_duration_qty: "",
    maximum_duration_unit: "",
    term_minimum_duration_qty: "",
    term_minimum_duration_unit: "",
    term_maximum_duration_qty: "",
    term_maximum_duration_unit: "",
    topic_unit_upto: "",
    nba_sar_type: "",
    program_type: "",
    program_mode: "",
    department: "",
    created_by: CustomChairmanMail,
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [course, setCourse] = useState({
    component_name: "",
    type: "",
    open_elective: "",
    description: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [programMode, setProgramMode] = useState({
    name: "",
    description: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [programOutcome, setProgramOutCome] = useState({
    type: "",
    description: "",
    created_by: CustomChairmanMail,
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [questionBank, setQuestionBank] = useState({
    topic: "",
    course: "",
    bloom_level: "",
    difficulty_level: "",
    question_type: "",
    questions: "",
    created_by: "admin",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
  });
  const [courseCurriculum, setCourseCurriculum] = useState({
    curriculum: "",
    term: "",
    domain: "",
    type_of_course: "",
    prerequisite_course: "",
    type: "",
    owner: "",
    code: "",
    title: "p",
    acronym: "",
    lecture_credits: "",
    tutor_credits: "",
    practical_credits: "",
    total_credits: "",
    total_ISE_and_MSE_weightage: "",
    total_ESE_weightage: "",
    reviewer_department: "",
    course_reviewer: "",
    last_date_to_review: "",
    total_course_contact_hours: "",
    total_term_work_marks: "",
    total_mid_term_marks: "",
    total_theory_marks: "",
    total_marks: "",
    ese_duration: "",
    created_at: new Date().toString(),
    updated_at: new Date().toString(),
    created_by: "superuser@test.com",
  });
  const [courseOutcome, setCourseOutcome] = useState({
    code: "dcff",
    cognitive_domain: "cmsd",
    course: "df",
    created_at: "2020-10-04T08:01:10.652880Z",
    created_by: "admin@test.com",
    delivery_method: "dsfdf",
    statement: "dfdsf",
    updated_at: new Date().toString(),
  });
  const handleSubmit = (event) => {
    event.preventDefault();
    document.getElementById("form").reset();
    props.onClose();
    if (props?.identify === "Department") {
      console.log(state);
      props.setdepartmentData(state);
      window.location.href = "/configuration/department";
    }
    if (props?.identify === "LabCategory") {
      props.setLabCategoryData(labCategory);
    }
    if (props?.identify === "BloomDomain") {
      console.log(bloomDomain);
      props.setBloomsDomainData(bloomDomain);
    }
    if (props?.identify === "BloomLevel") {
      props.setBloomsLevelData(bloomLevel);
    }
    if (props?.identify === "DeliveryMethod") {
      console.log(deliveryMethod);
      props.setDeliveryMethodData(deliveryMethod);
    }
    if (props?.identify === "MapLevelWeightage") {
      console.log(mapLevelWeightage);
      props.setMapLevelWeightageData(mapLevelWeightage);
    }
    if (props?.identify === "ProgramType") {
      props.setProgramTypeData(programType);
    }
    if (props?.identify === "Program") {
      console.log(program);
      props.setProgramData(program);
    }
    if (props?.identify === "Course") {
      console.log(course);
      props.setCourseData(course);
    }
    if (props?.identify === "ProgramMode") {
      props.setProgramModeData(programMode);
    }
    if (props?.identify === "ProgramOutcome") {
      props.setProgramOutcomeData(programOutcome);
    }
    if (props?.identify === "QuestionBank") {
      props.setQuestionBankData(questionBank);
    }
    if (props?.identify === "CourseCurriculum") {
      props.setCourseCurriculumData(courseCurriculum);
    }
    if (props?.identify === "CourseOutcome") {
      console.log(courseOutcome);
      props.setCourseOutcomeData(courseOutcome);
    }
  };
  // const handleForm  = ()=>{
  //       document.getElementById('form-button').click()
  //       props.onClose()
  //   }
  const handleChange = (event) => {
    if (props?.identify === "Department") {
      console.log(state);
      dataState({ ...state, [event.target.id]: event.target.value });
    }
    if (props?.identify === "LabCategory") {
      setLabCategory({ ...labCategory, [event.target.id]: event.target.value });
    }
    if (props?.identify === "BloomDomain") {
      setBloomDomain({ ...bloomDomain, [event.target.id]: event.target.value });
    }
    if (props?.identify === "BloomLevel") {
      setBloomLevel({ ...bloomLevel, [event.target.id]: event.target.value });
    }
    if (props?.identify === "DeliveryMethod") {
      setDeliveryMethod({
        ...deliveryMethod,
        [event.target.id]: event.target.value,
      });
    }
    if (props?.identify === "MapLevelWeightage") {
      if (event.target.type === "number") {
        setMapLevelWeightage({
          ...mapLevelWeightage,
          [event.target.id]: parseInt(event.target.value),
        });
      } else {
        setMapLevelWeightage({
          ...mapLevelWeightage,
          [event.target.id]: event.target.value,
        });
      }
    }
    if (props?.identify === "ProgramType") {
      setProgramType({ ...programType, [event.target.id]: event.target.value });
    }
    if (props?.identify === "Program") {
      if (event.target.type === "number") {
        setprogram({
          ...program,
          [event.target.id]: parseInt(event.target.value),
        });
      } else {
        setprogram({ ...program, [event.target.id]: event.target.value });
      }
    }
    if (props?.identify === "Course") {
      setCourse({ ...course, [event.target.id]: event.target.value });
    }
    if (props?.identify === "ProgramMode") {
      setProgramMode({ ...programMode, [event.target.id]: event.target.value });
    }
    if (props?.identify === "ProgramOutcome") {
      setProgramOutCome({
        ...programOutcome,
        [event.target.id]: event.target.value,
      });
    }
    if (props?.identify === "QuestionBank") {
      setQuestionBank({
        ...questionBank,
        [event.target.id]: event.target.value,
      });
    }
    if (props?.identify === "CourseCurriculum") {
      if (
        [
          "owner",
          "total_course_contact_hours",
          "total_term_work_marks",
          "total_mid_term_marks",
          "total_theory_marks",
          "total_marks",
          "ese_duration",
        ].includes(event.target.id)
      ) {
        setCourseCurriculum({
          ...courseCurriculum,
          [event.target.id]: parseInt(event.target.value),
        });
      } else {
        setCourseCurriculum({
          ...courseCurriculum,
          [event.target.id]: event.target.value,
        });
      }
    }
    if (props?.identify === "CourseOutcome") {
      setCourseOutcome({
        ...courseOutcome,
        [event.target.id]: event.target.value,
      });
    }
  };
  return (
    <div>
      <Dialog
        fullScreen
        open={props.open}
        onClose={props.onClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {props?.identify}
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={handleForm}>
              save
            </Button> */}
          </Toolbar>
        </AppBar>
        <form id="form" style={{ margin: "1rem 5rem" }} onSubmit={handleSubmit}>
          <div style={{ marginTop: "1rem" }}>
            {props?.identify === "Department" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      // style={{ width: "22rem" }}
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      maxLength="10"
                      id="short_name"
                      onChange={handleChange}
                      label="Short Name"
                      required={true}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="year_of_establishment"
                      onChange={handleChange}
                      label="Year Of Establishment"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="no_of_magazines"
                      onChange={handleChange}
                      label="Magazines"
                      required={false}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="professional_bodies"
                      onChange={handleChange}
                      label="Professional Bodies"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="no_of_journals"
                      onChange={handleChange}
                      label="Journals"
                      required={false}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomTextArea
                      id="vision"
                      onChange={handleChange}
                      label="Vision"
                      required={false}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="mission"
                      onChange={handleChange}
                      label="Mission"
                      required={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                      required={false}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="faculty"
                      onChange={handleChange}
                      label="Faculty"
                      required={false}
                    />
                  </div>
                </div>
              </>
            )}
            {props?.identify === "LabCategory" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                    />
                  </div>
                </div>
              </>
            )}
            {props.identify === "BloomDomain" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="acronym"
                      onChange={handleChange}
                      label="Acronym"
                      required={true}
                    />
                  </div>
                </div>

                <CustomTextArea
                  id="description"
                  onChange={handleChange}
                  label="Description"
                />
              </>
            )}
            {props?.identify === "BloomLevel" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="level_of_learning"
                      onChange={handleChange}
                      label="Level of Learning"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="characteristics_of_learning"
                      onChange={handleChange}
                      label="Characteristics of Learning"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="action_verb"
                      onChange={handleChange}
                      label="Action verb"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="domain"
                      onChange={handleChange}
                      label="Domain"
                    />
                  </div>
                </div>
              </>
            )}
            {props?.identify === "DeliveryMethod" && (
              <div className='row'>
                <div className='col-md-6'>
                <CustomInput
                  type="string"
                  id="name"
                  onChange={handleChange}
                  label="Name"
                 
                  required={true}
                />
                </div>
                <div className='col-md-6'>
                <CustomInput
                  type="string"
                  id="guidelines"
                  onChange={handleChange}
                  label="Guidelines"
                  
                />
                </div>
                {/* <CustomInput type='string' id="bloom_level" onChange={handleChange} label="Bloom Level" style={{width:'22rem'}} required={true}/> */}
                <CustomDropdown
                  label="bloom_level"
                  data={[{ value: "1" }, { value: "2" }, { value: "3" }]}
                  id="bloom_level"
                  onChange={handleChange}
                />
              </div>
            )}
            {props?.identify === "MapLevelWeightage" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="acronym"
                      onChange={handleChange}
                      label="Acronym"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="weightage"
                      onChange={handleChange}
                      label="Weightage"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      notDefaultOption={true}
                      label="Status"
                      data={[{ value: "True" }, { value: "False" }]}
                      id={"status"}
                      onChange={() =>
                        setMapLevelWeightage({
                          ...mapLevelWeightage,
                          status: !mapLevelWeightage.status,
                        })
                      }
                    />
                  </div>
                </div>
              </>
            )}
            {props?.identify === "ProgramType" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                    />
                  </div>
                </div>
              </>
            )}
            {props?.identify === "Program" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="specialization"
                      onChange={handleChange}
                      label="specialization"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="specialization_acronym"
                      onChange={handleChange}
                      label="specialization_acronym"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="number_of_terms"
                      onChange={handleChange}
                      label="number_of_terms"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="total_credits"
                      onChange={handleChange}
                      label="total_credits"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="term_min_credits"
                      onChange={handleChange}
                      label="term_min_credits"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="term_max_credits"
                      onChange={handleChange}
                      label="term_max_credits"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="title"
                      onChange={handleChange}
                      label="title"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="acronym"
                      onChange={handleChange}
                      label="acronym"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="minimum_duration_qty"
                      onChange={handleChange}
                      label="minimum_duration_qty"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="minimum_duration_unit"
                      data={[
                        { value: "Minutes" },
                        { value: "Hours" },
                        { value: "Days" },
                        { value: "Months" },
                        { value: "Years" },
                      ]}
                      id="minimum_duration_unit"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="maximum_duration_qty"
                      onChange={handleChange}
                      label="maximum_duration_qty"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="maximum_duration_unit"
                      data={[
                        { value: "Minutes" },
                        { value: "Hours" },
                        { value: "Days" },
                        { value: "Months" },
                        { value: "Years" },
                      ]}
                      id="maximum_duration_unit"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="term_minimum_duration_qty"
                      onChange={handleChange}
                      label="term_minimum_duration_qty"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="term_minimum_duration_unit"
                      data={[
                        { value: "Minutes" },
                        { value: "Hours" },
                        { value: "Days" },
                        { value: "Months" },
                        { value: "Years" },
                      ]}
                      id="term_minimum_duration_unit"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="number"
                      id="term_maximum_duration_qty"
                      onChange={handleChange}
                      label="term_maximum_duration_qty"
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="term_maximum_duration_unit"
                      data={[
                        { value: "Minutes" },
                        { value: "Hours" },
                        { value: "Days" },
                        { value: "Months" },
                        { value: "Years" },
                      ]}
                      id="term_maximum_duration_unit"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="nba sar type"
                      data={[
                        { value: "UndergraduateEngineering" },
                        { value: "PostgraduateEngineering" },
                        { value: "Diploma/Polytechnic" },
                        { value: "UndergraduatePharmacy" },
                        { value: "PostgraduateMBA" },
                      ]}
                      id="nba_sar_type"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      // notDefaultOption={true}
                      label="topic unit upto"
                      data={[
                        { value: "UnitI" },
                        { value: "UnitII" },
                        { value: "UnitIII" },
                        { value: "UnitIV" },
                        { value: "UnitV" },
                        { value: "UnitVI" },
                        { value: "UnitVII" },
                        { value: "UnitVIII" },
                      ]}
                      id="topic_unit_upto"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomDropdown
                      label="program_type"
                      data={props?.programType?.data?.map((d) => {
                        return { value: d.name };
                      })}
                      id="program_type"
                      onChange={handleChange}
                      notDefaultOption
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      label="program_mode"
                      data={props?.programMode?.data?.map((d) => {
                        return { value: d.name };
                      })}
                      id="program_mode"
                      onChange={handleChange}
                      notDefaultOption
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomDropdown
                      label="Department"
                      data={props?.department?.data?.map((d) => {
                        return { value: d.name };
                      })}
                      id="department"
                      onChange={handleChange}
                      notDefaultOption
                    />
                  </div>
                </div>
              </>
            )}

            {props?.identify === "Course" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="type"
                      onChange={handleChange}
                      label="type"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomDropdown
                      label="Name"
                      data={[
                        { value: "Basic" },
                        { value: "Core" },
                        { value: "Electives" },
                        { value: "Humaities&Sciences" },
                        { value: "Others" },
                        { value: "Projects" },
                      ]}
                      id="component_name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                    />
                  </div>

                  <div className="col-md-6">
                    <CustomDropdown
                      label="open_elective"
                      data={[{ value: "true" }, { value: "false" }]}
                      id="open_elective"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </>
            )}

            {props?.identify === "ProgramMode" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="name"
                      onChange={handleChange}
                      label="Name"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                    />
                  </div>
                </div>
              </>
            )}

            {props?.identify === "ProgramOutcome" && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <CustomInput
                      type="string"
                      id="type"
                      onChange={handleChange}
                      label="Type"
                      required={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <CustomTextArea
                      id="description"
                      onChange={handleChange}
                      label="Description"
                    />
                  </div>
                </div>
              </>
            )}

            {props?.identify === "QuestionBank" && (
              <div className='row'>
                <div className="col-md-4">
                <CustomDropdown
                  label="topic"
                  data={[{ value: "abcd" }, { value: "defg" }]}
                  id="topic"
                  onChange={handleChange}
                />
                </div>
                <div className="col-md-4">
                <CustomDropdown
                  label="course"
                  data={[{ value: "DAA" }, { value: "DBMS" }]}
                  id="course"
                  onChange={handleChange}
                />
                </div>
                <div className="col-md-4">
                <CustomDropdown
                  label="bloom_level"
                  data={[{ value: "1" }, { value: "2" }]}
                  id="bloom_level"
                  onChange={handleChange}
                />
                </div>
                <div className="col-md-4">
                <CustomDropdown
                  label="difficulty_level"
                  data={[{ value: "easy" }, { value: "hard" }]}
                  id="difficulty_level"
                  onChange={handleChange}
                />
                </div>
                <div className="col-md-4">
                <CustomDropdown
                  label="question_type"
                  data={[
                    { value: "Descriptive" },
                    { value: "Analytical" },
                    { value: "Design" },
                    { value: "Programming" },
                    { value: "Drawing" },
                    { value: "Professional" },
                    { value: "Ethical" },
                    { value: "Business Management" },
                    { value: "Problem Solving" },
                    { value: "Logical Reasoning" },
                  ]}
                  id="question_type"
                  onChange={handleChange}
                />
                </div>
                <div className="col-md-4">
                <CustomInput
                  type="string"
                  id="questions"
                  onChange={handleChange}
                  label="Questions"
                 
                  required={true}
                />
                </div>
              </div>
            )}

            {props?.identify === "CourseCurriculum" && (
              <>
                <div className="row">
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="curriculum"
                  onChange={handleChange}
                  label="Curriculum"
                 
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="term"
                  onChange={handleChange}
                  label="Term"
                  
                  required={true}
                />
                </div>
               
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="domain"
                  onChange={handleChange}
                  label="Domain"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="type_of_course"
                  onChange={handleChange}
                  label="Type Of Course"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="prerequisite_course"
                  onChange={handleChange}
                  label="Prerequisite Course"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="type"
                  onChange={handleChange}
                  label="Type"
                
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="owner"
                  onChange={handleChange}
                  label="owner"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="code"
                  onChange={handleChange}
                  label="Code"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="title"
                  onChange={handleChange}
                  label="Title"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="acronym"
                  onChange={handleChange}
                  label="Acronym"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="lecture_credits"
                  onChange={handleChange}
                  label="Lecture Credits"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="tutor_credits"
                  onChange={handleChange}
                  label="tutor_credits"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="practical_credits"
                  onChange={handleChange}
                  label="practical_credits"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_credits"
                  onChange={handleChange}
                  label="total_credits"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_ISE_and_MSE_weightage"
                  onChange={handleChange}
                  label="total_ISE_and_MSE_weightage"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_ESE_weightage"
                  onChange={handleChange}
                  label="total_ESE_weightage"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="reviewer_department"
                  onChange={handleChange}
                  label="reviewer_department"
                 
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="course_reviewer"
                  onChange={handleChange}
                  label="course_reviewer"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="date"
                  id="last_date_to_review"
                  onChange={handleChange}
                  label="last_date_to_review"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_course_contact_hours"
                  onChange={handleChange}
                  label="total_course_contact_hours"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_term_work_marks"
                  onChange={handleChange}
                  label="total_term_work_marks"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_mid_term_marks"
                  onChange={handleChange}
                  label="total_mid_term_marks"
                 
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_theory_marks"
                  onChange={handleChange}
                  label="total_theory_marks"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="total_marks"
                  onChange={handleChange}
                  label="total_marks"
                  
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="number"
                  id="ese_duration"
                  onChange={handleChange}
                  label="ese_duration"
                 
                />
                </div>
                </div>
              </>
            )}

            {props?.identify === "CourseOutcome" && (
        
              <div className='row'>
              <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="code"
                  onChange={handleChange}
                  label="CO Code"
                  
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="statement"
                  onChange={handleChange}
                  label="Course Outcome"
                  
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="cognitive_domain"
                  onChange={handleChange}
                  label="Bloom level"
                 
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="delivery_method"
                  onChange={handleChange}
                  label="Delivery Method"
                 
                  required={true}
                />
                </div>
                <div className="col-md-6">
                <CustomInput
                  type="string"
                  id="course"
                  onChange={handleChange}
                  label="Course"
                  
                  required={true}
                />
                </div>
                </div>
              
            )}
            <button id="form-button" hidden type="submit"></button>
            <CustomButton label="Save" type="submit" />
          </div>
        </form>
      </Dialog>
    </div>
  );
}
const mapActionToProps = {
  setdepartmentData,
  setLabCategoryData,
  setBloomsDomainData,
  setBloomsLevelData,
  setDeliveryMethodData,
  setProgramTypeData,
  setMapLevelWeightageData,
  setProgramData,
  setCourseData,
  setProgramModeData,
  setProgramOutcomeData,
  setQuestionBankData,
  setCourseCurriculumData,
  setCourseOutcomeData,
  getdepartmentData,
  getProgramTypeData,
  getProgramModeData,
};
const mapStateWithProps = (state) => ({
  department: state.data.department,
  programType: state.data.programType,
  programMode: state.data.programMode,
});
export default connect(mapStateWithProps, mapActionToProps)(FullScreenDialog);
